<template lang="pug">
  div(:class="themeClass")
    .sort-area
      .sort-area-inner
        .sort-area-menu
          span.count
            | {{ Number(total).toLocaleString() }}件
            | ヒット
        .sort-area-menu
          ul.menu
            li
              router-link(
                :to="{ name: /haken/.test(this.path) ? 'SearchHaken' : 'SearchJob', query: searchConditionParams() }",
                class="menu-list"
                :class="{ active: !/grouping/.test(this.path) }"
              )
                .only-pc リスト
            li
              router-link(
                :to="{ name: /haken/.test(this.path) ? 'SearchGroupingHaken' : 'SearchGroupingJob', query: searchGroupingConditionParams() }",
                class="menu-group"
                :class="{ active: /grouping/.test(this.path) }"
              )
                .only-pc グループ
        .sort-btn-wrapper
          JobSearchCsvDownload(:totalCount="totalCount")
          a.open-sort-button(@click="sort") 項目選択
          a.open-search-button(@click="toggleSidebar") 検索条件
          a.search-job-guide-button(@click="showJobGuide") 使い方
          a.inquiry-button(
            v-if="inquiryHref"
            :href="inquiryHref"
            target="_blank"
          ) 問い合わせ
          a.formrun-link-button(
            v-if="surveyHref"
            :href="surveyHref"
            target="_blank"
          ) アンケート
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
  import moment from 'moment'
  import JobSearchCsvDownload from '../search/JobSearchCsvDownload'
  import {
    DefaultViewEndCode,
    DefaultOrder,
    DefaultOrderDirection,
  } from '../../constants'

  export default {
    props: ['totalCount'],
    components: { JobSearchCsvDownload },
    data () {
      return {
        mynaviInquiryURL: 'https://forms.office.com/r/WAavph4N9w',
        kobotInquiryURL: 'https://form.run/@dip-net-BQek6is3imF2WT10NYeU',
        kobotSurveyURL: 'https://form.run/embed/@dip-net-qSYy3nKZccPoSgHhkhRb?embed=direct',
        leadleInquiryURL: 'https://docs.google.com/forms/d/e/1FAIpQLSfIKf6EZCoJcvAggt1_z1jXIsUW-0GDWLwTAO2_SJwvhwozDw/viewform',
        leadleSurveyURL: 'https://forms.gle/yYMJL7Lq794vBzu36',
      }
    },
    computed: {
      // 2025-10-27
      // 現状 service_information.js により ドメインによって oem が分けられている。
      // 将来的にoem_identifier でアカウントを分ける必要が出てくるかもしれない。
      // ...mapState({
      //   user: state => state.user.detail,
      //   client: state => state.client.detail,
      // }),
      ...mapGetters({
        apiQuery: 'searchJob/apiQuery',
      }),
      path () {
        return this.$route.path
      },
      total () {
        return this.totalCount
      },
      // 2025-10-27
      // 現状 service_information.js により ドメインによって oem が分けられている。
      // 将来的にoem_identifier でアカウントを分ける必要が出てくるかもしれない。
      // isKobot () {
      //   const id =
      //     (this.client && this.client.oem_partner_identifier) ||
      //     (this.user && this.user.client && this.user.client.oem_partner_identifier)
      //   return String(id) === 'kobot'
      // },
      themeClass () {
        if (location.hostname.includes('mynavi')) return 'theme-mynavi'
      },
      oemId () {
        const raw = (typeof this.identifier === 'function') ? this.identifier() : this.identifier
        if (raw === undefined || raw === null) return ''
        return String(raw).replace(/^\s+|\s+$/g, '').toLowerCase()
      },
      hasOemId () {
        return this.oemId.length > 0
      },
      isKobot () {
        return this.oemId === 'kobot'
      },
      isMynavi () {
        return this.oemId === 'mynavi'
      },
      inquiryHref () {
        if (this.isKobot) return this.kobotInquiryURL
        if (this.isMynavi) return this.mynaviInquiryURL
        return this.leadleInquiryURL
      },
      surveyHref () {
        if (!this.hasOemId || this.isMynavi) return null

        if (this.isKobot) return this.kobotSurveyURL
        return this.leadleSurveyURL
      },
    },
    methods: {
      ...mapMutations('jobTableConfiguration', ['sort']),
      toggleSidebar () {
        this.$emit('toggleSidebar')
      },
      searchConditionParams () {
        const { query } = this.$route
        return {
          ...this.apiQuery,
          perPage: query.perPage,
          page: '1',
          order: DefaultOrder,
          orderDirection: DefaultOrderDirection,
          _t: Date.now(),
        }
      },
      searchGroupingConditionParams () {
        const { query } = this.$route
        const apiQuery = Object.assign({}, this.apiQuery)

        // 掲載状況
        if (apiQuery.acquisitionDate === '4') {
          if (!['0', '1', '2', '3', '4'].includes(apiQuery.viewEndDate)) {
            apiQuery.viewEndDate = DefaultViewEndCode
          }
        } else if (!['1', '2', '3', '4'].includes(apiQuery.viewEndDate)) {
          apiQuery.viewEndDate = DefaultViewEndCode
        }

        // カレンダー
        if (apiQuery.fromAcquisitionDate && apiQuery.toAcquisitionDate) {
          const diffMilliSec = new Date(apiQuery.toAcquisitionDate) - new Date(apiQuery.fromAcquisitionDate)
          const diffDays = parseInt(diffMilliSec / 1000 / 60 / 60 / 24, 10)

          if (diffDays > 180) {
            apiQuery.toAcquisitionDate = moment(apiQuery.fromAcquisitionDate).add(180, 'd').format('YYYY-MM-DD')
          }
        }
        apiQuery.order = DefaultOrder
        apiQuery.orderDirection = DefaultOrderDirection
        return Object.assign(apiQuery, { perPage: query.perPage, page: '1', _t: Date.now() })
      },
      showJobGuide () {
        this.$store.commit('guide/showJobModal')
      },
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/parts/JobSortArea.vue